import type { SnapshotView, SnapshotViewTemplateGroup } from "@/modules/snapshots/snapshotViews.types";

const SOURCE_UNAVAILABLE_ID = "source-unavailable";
const SOURCE_UNAVAILABLE_NAME = "Source unavailable";

const compareNamesAndIds = (leftName: string, leftId: string, rightName: string, rightId: string) => {
  const nameOrder = leftName.localeCompare(rightName, undefined, { sensitivity: "base" });
  return nameOrder || leftId.localeCompare(rightId);
};

const compareSourceGroups = (leftName: string, leftId: string, rightName: string, rightId: string) => {
  if (leftId === SOURCE_UNAVAILABLE_ID) return 1;
  if (rightId === SOURCE_UNAVAILABLE_ID) return -1;
  return compareNamesAndIds(leftName, leftId, rightName, rightId);
};

export const buildSnapshotViewHierarchy = (views: SnapshotView[]): SnapshotViewTemplateGroup[] => {
  const templates = new Map<string, SnapshotViewTemplateGroup>();

  for (const view of views) {
    const templateId = view.template_id ?? SOURCE_UNAVAILABLE_ID;
    const templateName = view.template_name ?? SOURCE_UNAVAILABLE_NAME;
    const collectionId = view.snapshot_collection_name ? view.snapshot_collection_id : SOURCE_UNAVAILABLE_ID;
    const collectionName = view.snapshot_collection_name ?? SOURCE_UNAVAILABLE_NAME;
    let template = templates.get(templateId);
    if (!template) {
      template = { id: templateId, name: templateName, viewCount: 0, collections: [] };
      templates.set(templateId, template);
    }
    let collection = template.collections.find(group => group.id === collectionId);
    if (!collection) {
      collection = { id: collectionId, name: collectionName, viewCount: 0, views: [] };
      template.collections.push(collection);
    }
    collection.views.push(view);
    collection.viewCount += 1;
    template.viewCount += 1;
  }

  for (const template of templates.values()) {
    template.collections.sort((left, right) => compareSourceGroups(left.name, left.id, right.name, right.id));
    for (const collection of template.collections) {
      collection.views.sort((left, right) => compareNamesAndIds(left.name, left.id, right.name, right.id));
    }
  }

  return Array.from(templates.values()).sort((left, right) =>
    compareSourceGroups(left.name, left.id, right.name, right.id),
  );
};
